import CollectionPanel from '~/js/components/wedding-styler/collection-details/CollectionPanel';

const {inspirationURLParameter, inspirationItems, inspirations, eventsData, isMobile, countries, isAuthenticated } = beaches_app.page;

ReactDOM.render(
  <CollectionPanel
    inspirationURLParameter={inspirationURLParameter}
    inspirations={inspirations}
    inspirationItems={inspirationItems}
    inspirationEvents={eventsData}
    isMobile={isMobile}
    countries={countries}
    isAuthenticated={isAuthenticated}
  />,
  document.getElementById('collection-panel')
);
